module.exports = __webpack_public_path__ + "img/devil-jin.ac31bb56.jpg";